/**
 * @generated SignedSource<<de63ff606cc2c5441383e95c6fa357c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "cancelNominatedTrade",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cancelledAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "cancelledBy",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "givenName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "familyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelNominatedTradeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelNominatedTradeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8d64a601cf874459f6be686da793698e",
    "id": null,
    "metadata": {},
    "name": "CancelNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation CancelNominatedTradeMutation(\n  $id: ID!\n) {\n  cancelNominatedTrade(id: $id) {\n    id\n    cancelledAt\n    cancelledBy {\n      id\n      email\n      givenName\n      familyName\n    }\n  }\n}\n"
  }
};
})();

node.hash = "f61e56424ecd83d2e3510c3f498f21d4";

module.exports = node;
